/**
 * Address parameters that must never reach Meta, which attaches the page's full URL to every event:
 *
 *  - `idea`: the visitor's own typed sentence (the landing hero, an ad). The privacy policy says Meta
 *    is never sent a prompt.
 *  - `t`: V7's "it's ready" email link token (/new/ready?t=…), which signs somebody in.
 *  - `link`: V6's "email me my app link" token (/new/building?link=…), which opens their build.
 *
 * Each screen takes its own out of the address on arrival; until it has, nothing is sent.
 */
// `ba`/`bk`/`bn`: a build carried from an app's own browser to Safari or Chrome (platform/openInBrowser.ts).
const PRIVATE_PARAMS = ['idea', 't', 'link', 'ba', 'bk', 'bn'] as const;

export function carriesPrivate(search: string): boolean {
  const params = new URLSearchParams(search);
  return PRIVATE_PARAMS.some((p) => params.has(p));
}
